/**
 * studio-shop D4, web-studio-sites D7: what the bag's current state requires a drawing to show: nothing while it
 * is closed, empty or being priced; why it failed; else each item in its entry (its name, option, how many and its
 * price, or that it is no longer available; Remove; the price it was, when that changed), the subtotal, and
 * Checkout while an item is available.
 */
import type { RequiredPart, RequiredParts } from '../../contract/required';
import type { ShopBagState } from './contract';

export const requiredParts: RequiredParts<ShopBagState> = (state) => {
  if (!state.open) return [];
  if (state.status === 'failed') return [{ part: 'problem' }];
  if (state.status !== 'ready') return [];
  const lines = state.lines.flatMap((line): RequiredPart[] => {
    const inLine = (part: string, action?: string): RequiredPart => ({ part, item: line.optionId, in: 'line', ...(action ? { action } : {}) });
    return [
      { part: 'line', item: line.optionId },
      inLine('name'),
      inLine('option'),
      ...(line.available ? [inLine('quantity'), inLine('price')] : [inLine('unavailable')]),
      inLine('remove', 'remove'),
      ...(line.was ? [inLine('changed')] : []),
    ];
  });
  return [...lines, { part: 'subtotal' }, ...(state.canCheckout ? [{ part: 'checkout', action: 'checkout' }] : [])];
};
